'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _lodash = require('lodash');

function infiniteScroll() {
	'ngInject';
	var directive = {
		restrict: 'A',
		link: link,
		scope: {
			paginationFunc: '=',
			elementTarget: '@'
		}
	};

	return directive;

	function link(scope, _element) {
		var element = scope.elementTarget ? angular.element(document.querySelector(scope.elementTarget)) : _element;
		scope.eventAdded = false;
		var range = 100;
		var scrollCallback = (0, _lodash.throttle)(_scrollCallback, 1000);

		element.on('scroll', scrollCallback);
		scope.$on('$destroy', function () {
			element.off('scroll', scrollCallback);
		});

		if (!scope.eventAdded) {
			scope.eventAdded = true;
			element.on('scroll', scrollCallback);
		}

		function _scrollCallback() {
			if (element[0].scrollTop + element[0].offsetHeight + range >= element[0].scrollHeight) {
				scope.paginationFunc();
			}
		}
	}
}

exports['default'] = infiniteScroll;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/infinite-scroll/infinite-scroll.directive.js
 **/